import { useContext } from "react"
import { PlanContext } from "../context/plan"

export default function usePlanPricing() {
    const { aiPlanPricing, setAIPlanPricing } = useContext(PlanContext)

    return {
        aiPlanPricing,
        setAIPlanPricing,
    }
}
